import { SyncSwapClassicPool__factory } from '@contracts';
import { VenoSDKModule } from './base';
import { ONE_USD } from './constants';
import SyncSwapEthUsdtClassicPoolModule from './SyncSwapEthUsdtClassicPool';
export default class SyncSwapLethEthClassicPoolModule extends VenoSDKModule {
    constructor() {
        super(...arguments);
        this.contractFactory = SyncSwapClassicPool__factory;
        this.contractAddress = this.sdk.addresses.ferroLp;
        this.SyncSwapEthUsdClassicPool = new SyncSwapEthUsdtClassicPoolModule(this.sdk);
    }
    async balanceOf(address) {
        return this.getContract().balanceOf(address);
    }
    async getLpUsdWorth(lpAmount) {
        const [[ethReserves, lethReserves], ethPrice, totalSupply] = await Promise.all([
            this.getContract().getReserves(),
            this.SyncSwapEthUsdClassicPool.getEthPrice(),
            this.getContract().totalSupply(),
        ]);
        const lethPrice = ethPrice.mul(ethReserves).div(lethReserves);
        // ethPrice / ONE_USD * ethReserves + lethPrice / ONE_USD * lethReserves
        const tvl = ethPrice
            .mul(ethReserves)
            .add(lethPrice.mul(lethReserves))
            .div(ONE_USD);
        const lpPrice = ONE_USD.mul(tvl).div(totalSupply);
        return lpPrice.mul(lpAmount).div(ONE_USD);
    }
}
